import React, { useState, useEffect } from "react";
import CButton from "../../../basecomp/components/CButton";
import CDateTimePicker from "../../../basecomp/components/CDateTimePicker";
import CMainGrid from "../../../basecomp/components/wrapper/CMainGrid";
import CDropDown from "../../../basecomp/components/CDropDown";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ViewModuleOutlinedIcon from "@mui/icons-material/ViewModuleOutlined";
import UploadTemplatesVM from "../viewmodel/UploadTemplatesVM";
import MaterialCreationLoader from "./MaterialCreationLoader";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
const buttonStyle = {
  "& > span > button": {
    background: "linear-gradient(135deg, #042560 0%, #042560 100%) !important",
    color: "#ffffff !important",
    borderRadius: "10px !important",
    fontWeight: "700 !important",
    textTransform: "none !important",
    boxShadow: "0 8px 20px rgba(4, 37, 96, 0.25) !important",
    transition: "all 0.2s ease !important",
    "&:hover": {
      transform: "translateY(-2px) !important",
      boxShadow: "0 12px 24px rgba(4, 37, 96, 0.35) !important",
    },
  },
};

const UploadTemplatesView = () => {
  const { handleStartDateChange, handleEndDateChange, handleUpload } =
    UploadTemplatesVM();

  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [downloadState, setDownloadState] = useState({
    loading: false,
    label: "",
  });
  

  const templateOptions = [
    "All terminal Upload template",
    "GT00 Upload Template",
  ];

  const allTerminalFields = [
    { enter: "Taxonomy", key: "taxonomy" },
    { enter: "Long Description", key: "long_description" },
    { enter: "Eq Function", key: "equipment_function" },
    { enter: "Manufacturer", key: "manufacturer" },
    { enter: "MFR Part Profile", key: "mfr_part_profile" },
    { enter: "MPN", key: "mpn" },
    { enter: "IND STD Desc", key: "ind" },
  ];

  const gt00Fields = [
    { enter: "Taxonomy", key: "taxonomy" },
    { enter: "Long Description", key: "long_description" },
    { enter: "MFR Part Profile", key: "mfr_part_profile" },
    { enter: "MPN", key: "mpn" },
    { enter: "Extend", key: "extend" },
    { enter: "Creation in GT00", key: "creation" },
    { enter: "IND STD Desc", key: "ind" },
  ];

  const currentFields =
    selectedTemplate === "All terminal Upload template"
      ? allTerminalFields
      : gt00Fields;

  const handleTemplateChange = (value) => {
 
    setSelectedTemplate(value);
  };

  const handleTemplateDownload = async (item) => {
    try {
      setDownloadState({ loading: true, label: item.enter });
      await handleUpload(item.key, selectedTemplate);
    } finally {
      setDownloadState({ loading: false, label: "" });
    }
  };

  useEffect(() => {
    const fontId = "lato-font-link";
    if (!document.getElementById(fontId)) {
      const link = document.createElement("link");
      link.id = fontId;
      link.href =
        "https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
  }, []);

  const outerTheme = useTheme();
  const localTheme = createTheme(outerTheme, {
    typography: {
      ...outerTheme.typography,
      fontFamily: "Lato, sans-serif",
    },
  });

  

  return (
    <ThemeProvider theme={localTheme}>
      <>
       
        <MaterialCreationLoader
          open={downloadState.loading}
          variant="download"
          title={`Preparing ${downloadState.label || "template"} file`}
          message="Generating the selected template and starting the Excel download."
        />
        <MaterialCreationLoader
          open={downloadState.loading}
          variant="download"
          title={`Preparing ${downloadState.label || "template"} file`}
          message="Generating the selected template and starting the Excel download."
        />
        <CMainGrid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          sx={{ margin: "6em 0.75em 1em" }}
        >
          <Paper
            elevation={0}
            sx={{
              borderRadius: "8px",
              border: "1px solid #dbe3ef",
              overflow: "visible",
              boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
              background: "#ffffff",
            }}
          >
            {/* ── Header ── */}

            {/* ── Body ── */}
            <Box sx={{ p: { xs: 2, md: 3 } }}>
              <Stack spacing={3}>
                
                <CMainGrid container spacing={2} alignItems="flex-start">
                  <CMainGrid item xs={12} sm={2} md={4}>
                    <Box
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                          alignItems: "center",
                        },
                        "& .MuiSelect-select": {
                          display: "flex",
                          alignItems: "center",
                          height: "40px",
                          boxSizing: "border-box",
                        },
                        "& input": {
                          padding: "0 14px",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",
                            height: "100%",
                          },
                          "& .MuiInputBase-root": {
                            height: 40,
                          },
                        }}
                      >
                        <CDropDown
                          cId="dd_template_type"
                          cHelperText="Select Template Type"
                          cData={templateOptions}
                          cOnChange={handleTemplateChange}
                          cFullWidth={true}
                          cValue={selectedTemplate}
                        />
                      </Box>
                    </Box>
                  </CMainGrid>
                  <CMainGrid item xs={12} sm={4} md={4}>
                    <Box
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "8px 14px",
                        },
                      }}
                    >
                      <CDateTimePicker
                        cHelperText="Start Date"
                        cOnChange={handleStartDateChange}
                        cFullWidth={true}
                      />
                    </Box>
                  </CMainGrid>
                  <CMainGrid item xs={12} sm={4} md={4}>
                    <Box
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "8px 14px",
                        },
                      }}
                    >
                      <CDateTimePicker
                        cHelperText="End Date"
                        cOnChange={handleEndDateChange}
                        cFullWidth={true}
                      />
                    </Box>
                  </CMainGrid>
                </CMainGrid>

    
                <CMainGrid container spacing={2}>
                  
                  {currentFields.map((item) => (
                    
                    <CMainGrid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={4}
                      xl={4}
                      key={item.key}
                    >
                      <Box
                        sx={{
                          p: 1.5,
                          border: "1px solid #dbe3ef",
                          borderRadius: "8px",
                          backgroundColor: "#f8fafc",
                          position: "relative",
                          overflow: "hidden",
                          transition:
                            "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            top: -36,
                            right: -26,
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            background: "rgba(37, 99, 235, 0.08)",
                            transition: "transform 200ms ease",
                          },
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
                            borderColor: "#93c5fd",
                          },
                          "&:hover::after": {
                            transform: "scale(1.25)",
                          },
                        }}
                      >
                        <Stack direction="row" spacing={1} alignItems="center">
                          <FileDownloadOutlinedIcon sx={{ color: "#2563eb" }} />
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              sx={{
                                fontSize: 11,
                                fontWeight: 800,
                                color: "#64748b",
                                mb: 0.75,
                              }}
                            >
                              {item.key}
                            </Typography>
                            {/* ── Styled download button ── */}
                            <Box sx={buttonStyle}>
                              <CButton
                                cId="mct_btn_download_excel"
                                cText={
                                  downloadState.loading &&
                                  downloadState.label === item.enter ? "Downloading..."
                                    : item.enter
                                }
                                cFullWidth={"true"}
                                cOnClick={() => handleTemplateDownload(item)}
                                cDisabled={downloadState.loading}
                              />
                            </Box>
                          </Box>
                        </Stack>
                      </Box>
                    </CMainGrid>
                  ))}
                </CMainGrid>
              </Stack>
            </Box>
          </Paper>
        </CMainGrid>
      </>
    </ThemeProvider>
  );
};

export default UploadTemplatesView;
